import birthdayTemplate from '../../angular/birthday-picker.pug';
import monthsOfTheYear from '../data/monthsOfTheYear.json';
import moment from 'moment';

var birthdayDirective = function (config) {
  return {
    restrict: 'E',
    scope: {
      min: '=',
      max: '=',
      required: '='
    },
    require: '?ngModel',
    template: birthdayTemplate,
    link: function (scope, elem, attrs, ngModel) {
      var birthday = null;
      function init () {
        scope.birthday = {
          year: null,
          month: null,
          date: null
        };
        scope.monthsOfTheYear = monthsOfTheYear;
        scope.$watchCollection('birthday', checkBirthday);
      }

      function checkBirthday () {
        var missingFields = false;
        if (scope.birthday.year === null || scope.birthday.month === null || scope.birthday.day === null) {
          missingFields = true;
        }

        ngModel.$setValidity('required', !missingFields);

        if (!missingFields) {
          var year = parseInt(scope.birthday.year, 10);
          var month = parseInt(scope.birthday.month, 10);
          var date = parseInt(scope.birthday.date, 10);

          if (scope.birthday.year && scope.birthday.year.length === 2) {
            year = 1900 + year;
          }

          var dateObj = moment([year, month, date]).startOf('day');
          var isValidDate = (
            dateObj.year() === year &&
            dateObj.month() === month &&
            dateObj.date() === date
          );

          ngModel.$setValidity('invalid', isValidDate);

          if (scope.min && isValidDate) {
            var minDate = moment(scope.min).startOf('day');
            ngModel.$setValidity('min', minDate.diff(dateObj) <= 0);
          }

          if (scope.max && isValidDate) {
            var maxDate = moment(scope.max).startOf('day');
            ngModel.$setValidity('max', maxDate.diff(dateObj) >= 0);
          }

          ngModel.$setViewValue(dateObj.format('YYYY-MM-DD'));
        }
      }

      ngModel.$render = function () {
        if (ngModel.$modelValue) {
          birthday = moment(ngModel.$modelValue);
          scope.birthday = {
            year: birthday.year(),
            month: birthday.month(),
            date: birthday.date()
          };
        }
        checkBirthday();
      };

      init();
    }
  };
};

export default birthdayDirective;



//////////////////
// WEBPACK FOOTER
// ./src/js/directives/birthdayPickerDirective.js
// module id = 32
// module chunks = 0